import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SyncRequiredDialogData } from "./sync-required-dialog.interface";

@Component({
  selector: "app-sync-required-dialog",
  templateUrl: "./sync-required-dialog.component.html",
  styleUrls: ["./sync-required-dialog.component.scss"],
  standalone: false,
})
export class SyncRequiredDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<SyncRequiredDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SyncRequiredDialogData,
  ) {}

  goToSync(): void {
    this.data.onSync();
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
